import React from 'react';
import { CalendarIcon, EditIconPencil } from '../../../../Assets/icons';
import CommonCard from '../../../../Components/General/CommonCard';
import AccordionItem from '../../../../Components/UI/AccordionItem';
import AccordionWrapper from '../../../../Components/UI/AccordionWrapper';
import classes from './UpcommingAppointmentAccordion.module.css';
import moment from 'moment-timezone';
const Header = () => {
  return (
    <span className={classes.wrapper}>
      <span className={classes.frame}>
        <CalendarIcon color="var(--primary-color)" size={20} />
      </span>
      <span className={classes.name}>Upcoming Appointments</span>
    </span>
  );
};

const extractDate = (dateTimeStr) => {
  return moment(dateTimeStr).format('DD MMM YYYY'); // Example: 01 Jan 2025
};

const extractTime = (dateTimeStr) => {
  return moment(dateTimeStr).format('hh:mm A'); // Example: 03:52 PM
};
const UpcomingAppointmentAccordion = ({
  data = [],
  value = [],
  setter = () => {},

  show
}) => {
  return (
    <AccordionWrapper className={classes.accordionWrapper} show={show}>
      <AccordionItem className={classes.accordionItem} eventKey={'upcoming'} header={<Header />}>
        <ul className={classes.listWrapper}>
          {data?.map((appointment, index) => {
            return (
              <li key={appointment?.visitNumber}>
                <div className={classes.infoAction}>
                  <p>{extractDate(appointment?.appointmentEndDateTime)}</p>
                  <p className={classes.timeValue}>
                    {extractTime(appointment?.appointmentEndDateTime)}
                  </p>
                  <CommonCard
                    type="button"
                    Tag="button"
                    className={classes.iconWrapper}
                    onClick={() => {
                      if (typeof setter === 'function') setter(appointment);
                    }}>
                    <EditIconPencil color="var(--primary-color)" size={18} />
                  </CommonCard>
                </div>
              </li>
            );
          })}
        </ul>
        <div className={classes.viewAllWrapper}>
          <span className={classes.viewAll}>View All</span>
        </div>
      </AccordionItem>
    </AccordionWrapper>
  );
};

export default UpcomingAppointmentAccordion;
